<template>
  <div class="main-header-serial-number">
    {{ title }}
    <b class="main-header-serial-number--b"
       :class="{ 'b-empty shine-short': !carLoaded && !this.entryNumber, blue:this.entryNumber }">
      {{ carId }}
    </b>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
export default {
  props: {
    entryNumber: {
      type: String,
      required: false
    }
  },
  computed: {
    ...mapGetters(["carLoaded"]),
    car() {
      return this.$store.state.dealers.newCar;
    },
    flagCarInStock() {
      return this.$route.name === "CarInStock";
    },/*
    dataLoadedCar() {
      return this.$store.getters.carLoaded;
    },
    flagCarInStock ? (registrationNumber ? registrationNumber : '')
    */
    title(){
      //flagCarInStock ? (registrationNumber ? 'Fastanúmer:' : '') : 'Raðnúmer:'

      if(this.flagCarInStock){
        return 'Fastanúmer';
      }

      return 'Raðnúmer';
    },
    registrationNumber() {
      return this.car ? this.car.registration_number : null;
    },
    carId() {
      if(this.flagCarInStock){
        return  this.registrationNumber;
      }

      return this.entryNumber ? this.entryNumber : this.car.id;
    }
  }
}
</script>